module.exports = __webpack_public_path__ + "static/media/0032.2b33b9f8.svg";